import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Search = function Search(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.385 11.472a7 7 0 10-1.486 1.342l2.662 2.662a1 1 0 001.414-1.414l-2.59-2.59zM7 12A5 5 0 107 2a5 5 0 000 10z",
    fill: "currentColor"
  }));
};
export default Search;